export default {
    getMonthName(months, value) {
        return months[value.month] + ', ' + value.year;
    }
};